<template>
  <div class="mask" @touchmove.self.prevent>
    <!-- 返回 -->
    <!-- <div class="titlebar" ref="titlebar">
      <div class="close" @click.self="handleClose"></div>
    </div> -->
    <!-- 轮播图 -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, i) in imgUrls" :key="i" @click.self="handleClose">
          <img
            :src="item"
            :class="{'hiddenImg': isShowPreview}"
            @click="showScaleImg($event, item)"
          />
        </div>
      </div>
    </div>
    <!-- 放大预览图 -->
    <div
      id="scalewrap"
      ref="scalewrap"
      class="scalewrap"
      v-if="isShowPreview"
      @click.self="handleClose"
    >
      <img
        id="scaleImg"
        :class="{
          'scaleimage': true,
          'scale1': scaleRate == 1,
          'scale2': scaleRate == 2,
          'scale3':scaleRate == 3
        }"
        :src="scaleImgUrl"
        @click="showScaleImg($event)"
      />
    </div>
    <!-- end -->
  </div>
</template>

<script>
/* eslint max-len:0 */
import Swiper from '../../../common/js/modules/swiper4';
import $ from '../../../common/js/zepto';

export default {
  props: ['imgUrls', 'currentIndex'],
  data() {
    return {
      mySwiper: null,
      isShowPreview: false,
      scaleRate: 1,
      scaleImgUrl: '',
      top: window.scrollY, // 滑动图片时页面会跟随滑动，记录当前body的top值
      dbClickFlag: false, // ios端双击事件有问题，js模拟双击事件
      dbClickTimer: null,
    };
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, this.top); // 回到原先的top
  },
  methods: {
    handleClose() {
      this.$emit('closeImagePopup');
    },
    initSwiper() {
      this.mySwiper = new Swiper('.swiper-container', {
        touchRatio: 1,
        initialSlide: this.currentIndex
      });

      document.body.style.position = 'fixed';
      document.body.style.top = `${-this.top}px`;
    },
    showScaleImg(event, imgUrl) {
      if (!this.dbClickFlag) {
        this.dbClickFlag = true;
        this.dbClickTimer = setTimeout(() => {
          this.dbClickFlag = false;
          clearTimeout(this.dbClickTimer);
          this.handleClose(); // 单击图片关闭弹层
        }, 300);
      } else {
        this.dbClickFlag = false;
        clearTimeout(this.dbClickTimer);
        if (imgUrl) {
          this.isShowPreview = true;
          this.scaleImgUrl = imgUrl;
        }
        if (this.scaleRate === 1) {
          this.scaleRate = 2;
          this.$nextTick(() => {
            this.scrollLeftHandle(event, 1);
          });
        } else if (this.scaleRate === 2) {
          this.scaleRate = 3;
          this.$nextTick(() => {
            this.scrollLeftHandle(event, 2);
          });
        } else if (this.scaleRate === 3) {
          this.scaleRate = 1;
          this.isShowPreview = false;
          this.scaleImgUrl = '';
          this.$nextTick(() => {});
        }
      }
    },
    scrollLeftHandle(event, progress) {
      const screenHeight = window.screen.height;
      const imgHeight = $('#scaleImg').height();
      if (imgHeight < screenHeight) {
        $('#scaleImg').addClass('addTop');
      } else {
        $('#scaleImg').removeClass('addTop');
      }

      const screenWidth = window.screen.width;
      const averWidth = window.screen.width / 3;
      const e = event || window.event;
      const startPosi = $('#scalewrap').scrollLeft();
      let move = null;
      if (e.clientX < averWidth) {
        move = progress === 1 ? 0 : startPosi * 1.5;
      } else if (e.clientX < averWidth * 2) {
        move = progress === 1
          ? screenWidth * 0.67
          : startPosi * 1.5 + averWidth * 0.67;
      } else {
        move = progress === 1
          ? screenWidth * 1.34
          : startPosi * 1.5 + averWidth * 1.34;
      }
      $('#scalewrap').scrollLeft(move);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../common/css/common-mixin";
@import "../css/swiper";
// titlebar
// .titlebar {
//   position: fixed;
//   z-index: 1000;
//   top: 0;
//   left: 0;
//   width: 0.96rem;
//   height: 0.96rem;
//   box-sizing: content-box;
//   .close {
//     position: absolute;
//     left: 0;
//     bottom: 0;
//     width: 0.96rem;
//     height: 0.96rem;
//     background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAB2klEQVRIia3WzYvOURTA8TPTNN6Nd7GwsPGn2I0kKSUlIk0SNSlloaRGsrCwUPYiK8lLkbckrwnZWLK1UFPGeD4Wj6fGM/c887zcW7/N797z/d57f7/OOYGo+IzgGqYxhaGa8FHc9P+4UBN+y/zxcyQGH6MRcSMixgtzV2rs/HZh53B50G+wCHcS+CUMIfqFL8HdBH5x7tp+4EtxL4FPta/vB/4ggZ8vxfQKf5TAz2Vx3cKX4XECP9spthv4CjxN4GcWil8IvhLPEvjpbk7faXIMzxP4qW7gnQRjeJnAJ7uFZ4JVeJXAT/YCLwnW4HUB3MDxXuHtgrV4m8CP9QOfK9iCdwn8aL/wlmAbviXwI4PAW4I3CfzQoHDEcERsLVSi3xHxvUK1i8BuzBRO8QvjNa4osB1fE8nOGoLAZnxJJLtqCAKb8LkgmdG8yoEFgY34VJDMYk8NQWADPiaSvTUEgfV4n0j21RAE1imnkFnsryEIeRL8gwM1BIHV8jR+sIYg5IWogcM1BKFZSl8kkmJa71XQkpSagQYmaghC3s7MK639CgLL8aQggRM1BKFzSzlZQxCaTfHDRDJRQ9CSlNr6D8NVymLEdETsiIj7be+v1jpB61mM6/jh39/0FyUP3NKbOXsDAAAAAElFTkSuQmCC")
//       no-repeat center center;
//     background-size: 0.24rem 0.42rem;
//   }
// }

.mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 1);
}
// 轮播图
.swiper-container {
  position: absolute;
  z-index: inherit;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow: visible;
  .swiper-slide {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: visible;
    overflow-y: scroll;
    img {
      position: relative;
      margin: auto;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      // 解决透明图片叠加时透底问题
      &.hiddenImg {
        opacity: 0;
      }
    }
  }
}
.scalewrap {
  position: fixed;
  z-index: inherit;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  height: 100vh;
  overflow: scroll;
  text-align: center;
  font-size: 0;
  .scaleimage {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    width: 100%;
    &.scale1 {
      width: 100%;
    }
    &.scale2 {
      width: 200%;
    }
    &.scale3 {
      width: 300%;
    }
  }
  .scaleimage.addTop {
    top: 0;
    bottom: 0;
  }
}

::-webkit-scrollbar {
  display: none;
}
.scalewrap::-webkit-scrollbar {
  display: none;
}
</style>
